module.exports = __webpack_public_path__ + "static/img/bg-bottom.fb0127e.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/screen/bg-bottom.png
// module id = Q3Ve
// module chunks = 1